"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrchestrationHandlers = void 0;
var msw_1 = require("msw");
var routes_1 = require("../routes");
var mock_states_1 = require("../mock-states");
var types_1 = require("../types");
var utils_1 = require("../utils");
var orchestration_1 = require("../fixtures/orchestration");
var fixtures_1 = require("../fixtures");
var domain_1 = require("@genoa/domain");
var handlePaymentBreakdown = function (req, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
    var funds, jsonBody;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                funds = 20000;
                return [4 /*yield*/, req.json()];
            case 1:
                jsonBody = _a.sent();
                return [2 /*return*/, res(ctx.status(200), ctx.json(new types_1.MockSuccessResponse({
                        funds: funds,
                        charged_to_card: Math.max(jsonBody.amount - funds, 0),
                        amount: jsonBody.amount,
                    })))];
        }
    });
}); };
// Add handlers for states here
var stateHandlers = (_a = {},
    _a[mock_states_1.AppMockStates.CANCELED] = [],
    _a[mock_states_1.AppMockStates.COVERED] = [],
    _a[mock_states_1.AppMockStates.ONBOARDING] = [
        msw_1.rest.get(routes_1.getAccountRegex, (0, utils_1.success)(orchestration_1.mockGetAccountOnboardingResponse)),
        msw_1.rest.get(routes_1.getCardsRegex, (0, utils_1.success)(orchestration_1.mockDebitCard)),
    ],
    _a[mock_states_1.AppMockStates.INCOME_VERIFICATION_ONBOARDING] = [
        msw_1.rest.get(routes_1.getAccountRegex, (0, utils_1.success)(orchestration_1.mockGetAccountOnboardingResponse)),
        msw_1.rest.post(routes_1.startVerificationRegex, function (req, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockSuccessResponse({ verification_url: '', link_token: '' })))];
            });
        }); }),
        msw_1.rest.post(routes_1.selfReportIncomeRegex, function (req, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockSuccessResponse({ need_further_verification: true })))];
            });
        }); }),
        msw_1.rest.post(routes_1.continueEvaluationRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockSuccessResponse({
                        instruction: 'InProgress',
                        risk_offer: {
                            offer_state: 'PendingEvaluate',
                            current_evaluate_step: 'VerifyIncome',
                        },
                    })))];
            });
        }); }),
    ],
    _a[mock_states_1.AppMockStates.DOCUMENT_VERIFICATION_ONBOARDING] = [
        msw_1.rest.get(routes_1.getAccountRegex, (0, utils_1.success)(orchestration_1.mockGetAccountOnboardingResponse)),
        msw_1.rest.post(routes_1.startVerificationRegex, function (req, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockSuccessResponse({ verification_url: '', link_token: '' })))];
            });
        }); }),
        msw_1.rest.post(routes_1.continueEvaluationRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockSuccessResponse({
                        instruction: 'EvaluationCompleted',
                        risk_offer: {
                            offer_state: 'PendingAccept',
                            current_evaluate_step: 'IdentityDocumentVerification',
                            onboarding_identity_document_verification: { resubmit: false },
                        },
                    })))];
            });
        }); }),
    ],
    _a[mock_states_1.AppMockStates.RESUME_ONBOARDING_INCOME_VERIFICATION] = [
        msw_1.rest.get(routes_1.getAccountRegex, (0, utils_1.success)(orchestration_1.mockGetAccountOnboardingResponse)),
        msw_1.rest.post(routes_1.startVerificationRegex, function (req, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockSuccessResponse({ verification_url: '', link_token: '' })))];
            });
        }); }),
        msw_1.rest.post(routes_1.selfReportIncomeRegex, function (req, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockSuccessResponse({ need_further_verification: true })))];
            });
        }); }),
        msw_1.rest.post(routes_1.continueEvaluationRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockSuccessResponse({
                        instruction: 'NeedsFurtherVerification',
                        risk_offer: {
                            offer_state: 'PendingEvaluate',
                            current_evaluate_step: 'VerifyIncome',
                        },
                        verification_status: domain_1.VerificationStatus.PENDING,
                    })))];
            });
        }); }),
    ],
    _a[mock_states_1.AppMockStates.RESUME_ONBOARDING_DOCUMENT_VERIFICATION] = [
        msw_1.rest.get(routes_1.getAccountRegex, (0, utils_1.success)(orchestration_1.mockGetAccountOnboardingResponse)),
        msw_1.rest.post(routes_1.continueEvaluationRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockSuccessResponse({
                        instruction: 'InProgress',
                        risk_offer: {
                            offer_state: 'PendingEvaluate',
                            current_evaluate_step: 'IdentityDocumentVerification',
                            onboarding_identity_document_verification: { resubmit: false },
                        },
                    })))];
            });
        }); }),
    ],
    _a[mock_states_1.AppMockStates.RESUME_ONBOARDING_CREDIT_BUILDER] = [
        msw_1.rest.get(routes_1.getAccountRegex, (0, utils_1.success)(orchestration_1.mockGetAccountOnboardingResponse)),
        msw_1.rest.get(routes_1.paymentStatusRegex, (0, utils_1.success)(orchestration_1.mockGetPaymentStatusCreditBuilder)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 125000,
            outstanding_security_deposit_amount: 0,
            slc_type: 'CREDIT_BUILDER',
            credit_builder_enabled: true,
        })),
    ],
    _a[mock_states_1.AppMockStates.CREDIT_BUILDER_ONBOARDING] = [
        msw_1.rest.get(routes_1.getAccountRegex, (0, utils_1.success)(orchestration_1.mockGetAccountOnboardingResponse)),
        msw_1.rest.get(routes_1.getCardsRegex, (0, utils_1.success)(orchestration_1.mockDebitCard)),
        msw_1.rest.get(routes_1.paymentStatusRegex, (0, utils_1.success)(orchestration_1.mockGetPaymentStatusCreditBuilder)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 125000,
            outstanding_security_deposit_amount: 0,
            slc_type: 'CREDIT_BUILDER',
            credit_builder_enabled: true,
        })),
    ],
    _a[mock_states_1.AppMockStates.WALLET_DISABLED] = [msw_1.rest.get(routes_1.walletSettingsRegex, (0, utils_1.success)({ enabled: false }))],
    _a[mock_states_1.AppMockStates.SETUP_CARD_NEW_CARD] = [msw_1.rest.get(routes_1.getCardsRegex, (0, utils_1.success)(orchestration_1.mockDebitCardNotStripeConnected))],
    _a[mock_states_1.AppMockStates.CREDIT_CARD_IN_APP] = [msw_1.rest.get(routes_1.getCardsRegex, (0, utils_1.success)(orchestration_1.mockCreditCard))],
    _a[mock_states_1.AppMockStates.CREDIT_CARD_ONBOARDING] = [msw_1.rest.get(routes_1.getCardsRegex, (0, utils_1.success)(orchestration_1.mockCreditCard))],
    _a[mock_states_1.AppMockStates.ADD_WITHDRAW_SPECIAL_FAILURES] = [
        msw_1.rest.post(routes_1.addFundsRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('W30006')))];
            });
        }); }),
        msw_1.rest.post(routes_1.withdrawFundsRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('W30012')))];
            });
        }); }),
    ],
    _a[mock_states_1.AppMockStates.USER_WALLET_INELIGIBLE] = [msw_1.rest.get(routes_1.walletEligibilityRegex, (0, utils_1.success)(orchestration_1.mockWalletIneligibleUser))],
    _a[mock_states_1.AppMockStates.VC_CANNOT_CANCEL] = [
        msw_1.rest.get(routes_1.cancelBillEligibilityRegex, (0, utils_1.success)(orchestration_1.mockCancelBillIneligible)),
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.selfPayVCIssuedBillStatus)),
    ],
    _a[mock_states_1.AppMockStates.BLOCK_SWITCH_TO_DEBIT_CANCEL_AUTH] = [
        msw_1.rest.get(routes_1.cancelBillEligibilityRegex, (0, utils_1.success)(orchestration_1.mockCancelBillIneligible)),
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.selfPayVCIssuedBillStatus)),
    ],
    _a[mock_states_1.AppMockStates.OPTED_OUT_RENT_REPORTING] = [msw_1.rest.get(routes_1.rentReportingOptInRegex, (0, utils_1.success)(orchestration_1.mockOptedOutRentReporting))],
    _a[mock_states_1.AppMockStates.DELETE_ELIGIBILITY_FAIL_V2] = [
        msw_1.rest.get(routes_1.deleteEligibilityRegex, (0, utils_1.success)(orchestration_1.mockDeleteAccountEligibilityFalse)),
    ],
    _a[mock_states_1.AppMockStates.AUTOPILOT_NOT_ELIGIBLE] = [
        msw_1.rest.get(routes_1.autopilotEligibilityRegex, (0, utils_1.success)({ eligible: false, configured: false })),
    ],
    _a[mock_states_1.AppMockStates.AUTOPILOT_NOT_CONFIGURED] = [
        msw_1.rest.get(routes_1.autopilotEligibilityRegex, (0, utils_1.success)({ eligible: true, configured: false })),
    ],
    _a[mock_states_1.AppMockStates.RELINK_INELIGIBLE] = [msw_1.rest.get(routes_1.relinkEligibilityRegex, (0, utils_1.success)(orchestration_1.mockRelinkEligibilityFalse))],
    _a[mock_states_1.AppMockStates.FLEX_ANYWHERE_ONBOARDING] = [
        msw_1.rest.get(routes_1.getResidentPrefillRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('Y6000')))];
            });
        }); }),
        msw_1.rest.get(routes_1.getAccountRegex, (0, utils_1.success)(orchestration_1.mockGetAccountOnboardingResponse)),
    ],
    _a[mock_states_1.AppMockStates.SLC_CLASSIC_FLEX_ANYWHERE_ONBOARDING] = [
        msw_1.rest.get(routes_1.getResidentPrefillRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('Y6000')))];
            });
        }); }),
        msw_1.rest.get(routes_1.getAccountRegex, (0, utils_1.success)(orchestration_1.mockGetAccountOnboardingResponse)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: true,
            pricing_enabled: true,
            slc_type: domain_1.SLCType.FLEX_ANYWHERE,
            credit_builder_enabled: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
        })),
    ],
    _a[mock_states_1.AppMockStates.VC_ISSUED_SLC] = [
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
        })),
    ],
    _a[mock_states_1.AppMockStates.SLC_ENABLED] = [
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
        })),
    ],
    _a[mock_states_1.AppMockStates.SLC_SIMPLIFIED_PAYMENTS_ENABLED] = [
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: true,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
        })),
    ],
    _a[mock_states_1.AppMockStates.EP_INSUFFICIENT_FUNDS] = [
        msw_1.rest.post(routes_1.billPayNowSubmitRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('B10013')))];
            });
        }); }),
        msw_1.rest.get(routes_1.autopilotEligibilityRegex, (0, utils_1.success)({ eligible: true, configured: false })),
        msw_1.rest.get(routes_1.billAmountRegex, (0, utils_1.success)(orchestration_1.mockBillAmountPayNow)),
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.updateCardInsufficientFundsBillStatus)),
    ],
    _a[mock_states_1.AppMockStates.EP_GENERIC_PAYMENT_FAILURE] = [
        msw_1.rest.post(routes_1.billPayNowSubmitRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('B10012')))];
            });
        }); }),
        msw_1.rest.get(routes_1.autopilotEligibilityRegex, (0, utils_1.success)({ eligible: true, configured: false })),
        msw_1.rest.get(routes_1.billAmountRegex, (0, utils_1.success)(orchestration_1.mockBillAmountPayNow)),
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.updateCardGenericBillStatus)),
    ],
    _a[mock_states_1.AppMockStates.EP_DEFAULT_PAYMENT_FAILURE] = [
        msw_1.rest.post(routes_1.billPayNowSubmitRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('B10015')))];
            });
        }); }),
        msw_1.rest.get(routes_1.autopilotEligibilityRegex, (0, utils_1.success)({ eligible: true, configured: false })),
        msw_1.rest.get(routes_1.billAmountRegex, (0, utils_1.success)(orchestration_1.mockBillAmountPayNow)),
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.updateCardDefaultBillStatus)),
    ],
    _a[mock_states_1.AppMockStates.EP_UPDATE_CARD] = [
        msw_1.rest.post(routes_1.billPayNowSubmitRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('B10014')))];
            });
        }); }),
        msw_1.rest.get(routes_1.autopilotEligibilityRegex, (0, utils_1.success)({ eligible: true, configured: false })),
        msw_1.rest.get(routes_1.billAmountRegex, (0, utils_1.success)(orchestration_1.mockBillAmountPayNow)),
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.updateCardBillStatus)),
    ],
    _a[mock_states_1.AppMockStates.SETUP_CARD_V2_CARD_LINKAGE_FAIL] = [
        msw_1.rest.post(routes_1.setupCardRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('W30001')))];
            });
        }); }),
    ],
    _a[mock_states_1.AppMockStates.SETUP_CARD_V2_CARD_LINKAGE_FAIL_ONBOARDING] = [
        msw_1.rest.post(routes_1.setupCardRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('W30001')))];
            });
        }); }),
    ],
    _a[mock_states_1.AppMockStates.SETUP_CARD_GENERIC_FAILURE] = [
        msw_1.rest.post(routes_1.setupCardRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('W30000')))];
            });
        }); }),
    ],
    _a[mock_states_1.AppMockStates.SETUP_CARD_GENERIC_FAILURE_ONBOARDING] = [
        msw_1.rest.post(routes_1.setupCardRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('W30000')))];
            });
        }); }),
    ],
    _a[mock_states_1.AppMockStates.SETUP_CARD_CAPITAL_ONE_FAILURE] = [
        msw_1.rest.post(routes_1.setupCardRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('W30002')))];
            });
        }); }),
    ],
    _a[mock_states_1.AppMockStates.SETUP_CARD_CAPITAL_ONE_FAILURE_ONBOARDING] = [
        msw_1.rest.post(routes_1.setupCardRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('W30002')))];
            });
        }); }),
    ],
    _a[mock_states_1.AppMockStates.WITHDRAW_FUNDS_MAX_WITHDRAWALS] = [
        msw_1.rest.post(routes_1.withdrawFundsRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('W30013')))];
            });
        }); }),
    ],
    _a[mock_states_1.AppMockStates.WITHDRAW_FUNDS_RENT_PAYMENT_PROCESSING] = [
        msw_1.rest.post(routes_1.withdrawFundsRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('W30014', 'We were unable to withdraw your funds because we’re in the process of paying your rent. Please wait until your rent payment has been paid or stopped before trying again.')))];
            });
        }); }),
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(orchestration_1.mockGetBillStatusResponsePayingRent)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: true,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 0,
        })),
    ],
    _a[mock_states_1.AppMockStates.ADD_WITHDRAW_FUNDS_GENERIC_ERRORS] = [
        msw_1.rest.post(routes_1.withdrawFundsRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('W30010')))];
            });
        }); }),
        msw_1.rest.post(routes_1.addFundsRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('W30004')))];
            });
        }); }),
    ],
    _a[mock_states_1.AppMockStates.ADD_WITHDRAW_RATE_LIMIT] = [
        msw_1.rest.post(routes_1.withdrawFundsRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('G20002')))];
            });
        }); }),
        msw_1.rest.post(routes_1.addFundsRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('G20002')))];
            });
        }); }),
    ],
    _a[mock_states_1.AppMockStates.WITHDRAW_FUNDS_10_SECOND_WAIT] = [
        msw_1.rest.post(routes_1.withdrawFundsRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('G20002')))];
            });
        }); }),
    ],
    _a[mock_states_1.AppMockStates.WITHDRAW_FUNDS_WITHDRAWAL_IN_PROGRESS] = [
        msw_1.rest.post(routes_1.withdrawFundsRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('W30015')))];
            });
        }); }),
    ],
    _a[mock_states_1.AppMockStates.READY_TO_PAY_OON_SLC_SP_ENABLED] = [
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: true,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
        })),
    ],
    _a[mock_states_1.AppMockStates.READY_TO_PAY_OON_SLC_SP_DISABLED] = [
        msw_1.rest.get(routes_1.getAccountRegex, (0, utils_1.success)(orchestration_1.mockGetAccountRelinkingResponse)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            slc_type: domain_1.SLCType.FLEX_ANYWHERE,
        })),
    ],
    _a[mock_states_1.AppMockStates.READY_TO_PAY_OON_SLC_SP_DISABLED_MONTH_TWO] = [
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
        })),
    ],
    _a[mock_states_1.AppMockStates.READY_TO_PAY_OON_SLC_SP_DISABLED_MONTH_TWO_ADDITIONAL_DEPOSIT] = [
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
        })),
    ],
    _a[mock_states_1.AppMockStates.TWO_REPAYMENTS_OON_SLC_SP_ENABLED_MONTH_TWO] = [
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: true,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
        })),
    ],
    _a[mock_states_1.AppMockStates.TWO_REPAYMENTS_OON_SLC_SP_DISABLED_MONTH_TWO] = [
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
        })),
    ],
    _a[mock_states_1.AppMockStates.READY_TO_PAY_OON_SLC_SP_DISABLED_MONTH_TWO_DEPOSIT_PAID] = [
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 0,
        })),
    ],
    _a[mock_states_1.AppMockStates.SLC_FLEX_CLASSIC_GET_READY] = [
        msw_1.rest.get(routes_1.getPaymentSchedule, (0, utils_1.success)({ payments: orchestration_1.mockUpdatedRentAmountSLCSchedule })),
        msw_1.rest.post(routes_1.updateEstimatedBillAmount, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('G30000')))];
            });
        }); }),
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(orchestration_1.mockGetBillStatusResponseDepositNotPaidFSLC)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            pricing_enabled: true,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.SLC_BALANCE_TOO_HIGH] = [
        msw_1.rest.get(routes_1.getPaymentSchedule, (0, utils_1.success)({ payments: orchestration_1.mockUpdatedRentAmountSLCSchedule })),
        msw_1.rest.post(routes_1.updateEstimatedBillAmount, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('G30000')))];
            });
        }); }),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            pricing_enabled: true,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.SLC_BALANCE_TOO_LOW] = [
        msw_1.rest.get(routes_1.getPaymentSchedule, (0, utils_1.success)({ payments: orchestration_1.mockUpdatedRentAmountSLCSchedule })),
        msw_1.rest.post(routes_1.updateEstimatedBillAmount, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('G30000')))];
            });
        }); }),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            pricing_enabled: true,
            SLCType: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.SLC_FLEX_CLASSIC_RENT_PAYMENT_PROCESSING] = [
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.SLC_FLEX_CLASSIC_COVERED] = [
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.SLC_UPDATE_CARD] = [
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.SLC_INSUFFICIENT_FUNDS] = [
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.SLC_GENERIC_PAYMENT_FAILURE] = [
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.SLC_DEFAULT_PAYMENT_FAILURE] = [
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.SLC_1ST_REPAYMENT_FAILED] = [
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.SLC_2ND_REPAYMENT_FAILED] = [
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.READY_TO_PAY_AUTOPILOT_ENABLED] = [
        msw_1.rest.get(routes_1.getPaymentSchedule, (0, utils_1.success)({ payments: orchestration_1.mockUpdatedRentAmountScheduleEpisodic })),
        msw_1.rest.get(routes_1.autopilotEligibilityRegex, (0, utils_1.success)({ eligible: true, configured: true })),
        msw_1.rest.get(routes_1.billAmountRegex, (0, utils_1.success)(orchestration_1.mockBillAmountPayNow)),
    ],
    _a[mock_states_1.AppMockStates.READY_TO_PAY_AUTOPILOT_DISABLED] = [
        msw_1.rest.get(routes_1.getPaymentSchedule, (0, utils_1.success)({ payments: orchestration_1.mockUpdatedRentAmountScheduleEpisodic })),
        msw_1.rest.get(routes_1.autopilotEligibilityRegex, (0, utils_1.success)({ eligible: true, configured: false })),
        msw_1.rest.get(routes_1.billAmountRegex, (0, utils_1.success)(orchestration_1.mockBillAmountPayNow)),
        msw_1.rest.get(routes_1.getBillPayConfigRegex, (0, utils_1.success)(fixtures_1.mockBillPayConfigurationCannotOverwrite)),
    ],
    _a[mock_states_1.AppMockStates.READY_TO_PAY_SLC_AUTOPILOT_ENABLED] = [
        msw_1.rest.get(routes_1.getPaymentSchedule, (0, utils_1.success)({ payments: orchestration_1.mockUpdatedRentAmountScheduleEpisodic })),
        msw_1.rest.get(routes_1.autopilotEligibilityRegex, (0, utils_1.success)({ eligible: true, configured: true })),
        msw_1.rest.get(routes_1.billAmountRegex, (0, utils_1.success)(orchestration_1.mockBillAmountPayNow)),
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(orchestration_1.mockGetBillStatusResponseEpisodicReadyToPay)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: true,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.READY_TO_PAY_SLC_AUTOPILOT_DISABLED] = [
        msw_1.rest.get(routes_1.getPaymentSchedule, (0, utils_1.success)({ payments: orchestration_1.mockUpdatedRentAmountScheduleEpisodic })),
        msw_1.rest.get(routes_1.autopilotEligibilityRegex, (0, utils_1.success)({ eligible: true, configured: false })),
        msw_1.rest.get(routes_1.billAmountRegex, (0, utils_1.success)(orchestration_1.mockBillAmountPayNow)),
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(orchestration_1.mockGetBillStatusResponseEpisodicReadyToPay)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: true,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.READY_TO_PAY_SLC_SP_OFF_AUTOPILOT_ENABLED] = [
        msw_1.rest.get(routes_1.getPaymentSchedule, (0, utils_1.success)({ payments: orchestration_1.mockUpdatedRentAmountScheduleEpisodic })),
        msw_1.rest.get(routes_1.autopilotEligibilityRegex, (0, utils_1.success)({ eligible: true, configured: true })),
        msw_1.rest.get(routes_1.billAmountRegex, (0, utils_1.success)(orchestration_1.mockBillAmountPayNow)),
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(orchestration_1.mockGetBillStatusResponseEpisodicReadyToPay)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.READY_TO_PAY_SLC_SP_OFF_AUTOPILOT_DISABLED] = [
        msw_1.rest.get(routes_1.getPaymentSchedule, (0, utils_1.success)({ payments: orchestration_1.mockUpdatedRentAmountScheduleEpisodic })),
        msw_1.rest.get(routes_1.autopilotEligibilityRegex, (0, utils_1.success)({ eligible: true, configured: false })),
        msw_1.rest.get(routes_1.billAmountRegex, (0, utils_1.success)(orchestration_1.mockBillAmountPayNow)),
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(orchestration_1.mockGetBillStatusResponseEpisodicReadyToPay)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.SLC_AUTOPAY_ON_RENT_PROTECT_ON_DEP_NOT_PD] = [
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(orchestration_1.mockGetBillStatusResponseDepositNotPaid)),
        msw_1.rest.get(routes_1.getAccountRegex, (0, utils_1.success)(orchestration_1.mockGetAccountRelinkingResponse)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: true,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 10000,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.SLC_AUTOPAY_ON_RENT_PROTECT_ON_DEP_PD] = [
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(orchestration_1.mockGetBillStatusResponseDepositFunded)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: true,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 0,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.SLC_AUTOPAY_ON_RENT_PROTECT_ON_PAYING_RENT] = [
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(orchestration_1.mockGetBillStatusResponsePayingRent)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: true,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 0,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.SLC_AUTOPAY_ON_RENT_PROTECT_ON_PAYMENT_SCHD] = [
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(orchestration_1.mockGetBillStatusResponseRentPaidUpcomingPayment)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: true,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 0,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.SLC_AUTOPAY_ON_RENT_PROTECT_ON_PAYMENT_PAID] = [
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(orchestration_1.mockGetBillStatusResponseFullyPaid)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: true,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 0,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.FSLC_AUTOPAY_ON_RENT_PROTECT_OFF_DEP_NOT_PD] = [
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(orchestration_1.mockGetBillStatusResponseDepositNotPaidFSLC)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 10000,
            slc_type: domain_1.SLCType.CREDIT_BUILDER,
        })),
    ],
    _a[mock_states_1.AppMockStates.SLC_CLASSIC_ENABLED] = [
        msw_1.rest.get(routes_1.getAccountRegex, (0, utils_1.success)(orchestration_1.mockGetAccountOnboardingResponse)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: true,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.FSLC_AUTOPAY_ON_RENT_PROTECT_OFF_DEP_PD] = [
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(orchestration_1.mockGetBillStatusResponseDepositFunded)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 0,
            slc_type: domain_1.SLCType.CREDIT_BUILDER,
        })),
    ],
    _a[mock_states_1.AppMockStates.FSLC_AUTOPAY_ON_RENT_PROTECT_OFF_PAYING_RENT] = [
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(orchestration_1.mockGetBillStatusResponsePayingRent)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 0,
            slc_type: domain_1.SLCType.CREDIT_BUILDER,
        })),
    ],
    _a[mock_states_1.AppMockStates.FSLC_AUTOPAY_ON_RENT_PROTECT_OFF_PAYMENT_SCHD] = [
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(orchestration_1.mockGetBillStatusResponseRentPaidUpcomingPayment)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 0,
            slc_type: domain_1.SLCType.CREDIT_BUILDER,
        })),
    ],
    _a[mock_states_1.AppMockStates.FSLC_AUTOPAY_ON_RENT_PROTECT_OFF_PAYMENT_PAID] = [
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(orchestration_1.mockGetBillStatusResponseFullyPaid)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 0,
            slc_type: domain_1.SLCType.CREDIT_BUILDER,
        })),
    ],
    _a[mock_states_1.AppMockStates.CREDIT_BUILDER_WALLET_ENABLED] = [
        msw_1.rest.get(routes_1.getCardsRegex, (0, utils_1.success)(orchestration_1.mockDebitCard)),
        msw_1.rest.get(routes_1.paymentStatusRegex, (0, utils_1.success)(orchestration_1.mockGetPaymentStatusCreditBuilderMonthTwo)),
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(orchestration_1.mockGetBillStatusCreditBuilderResponseFullyPaid)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 125000,
            outstanding_security_deposit_amount: 0,
            slc_type: domain_1.SLCType.CREDIT_BUILDER,
        })),
    ],
    _a[mock_states_1.AppMockStates.FSLC_RELINK_SERVICE_ISSUE] = [
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(orchestration_1.mockGetBillStatusResponseRelink)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 0,
            slc_type: domain_1.SLCType.CREDIT_BUILDER,
        })),
    ],
    _a[mock_states_1.AppMockStates.CREDIT_BUILDER_ENABLED] = [
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: true,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
        })),
    ],
    _a[mock_states_1.AppMockStates.CREDIT_BUILDER_RELINK] = [
        msw_1.rest.get(routes_1.getAccountRegex, (0, utils_1.success)(orchestration_1.mockGetAccountRelinkingResponse)),
        msw_1.rest.get(routes_1.paymentStatusRegex, (0, utils_1.success)(orchestration_1.mockGetPaymentStatusCreditBuilder)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: true,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            slc_type: domain_1.SLCType.CREDIT_BUILDER,
            credit_builder_enabled: true,
        })),
    ],
    _a[mock_states_1.AppMockStates.CREDIT_BUILDER_REPAYMENT_FAILED] = [
        msw_1.rest.get(routes_1.paymentStatusRegex, (0, utils_1.success)(orchestration_1.mockGetPaymentStatusCreditBuilderMonthTwoRepaymentFailed)),
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(orchestration_1.mockGetBillStatusResponseRentPaidUpcomingPayment)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: true,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            slc_type: domain_1.SLCType.CREDIT_BUILDER,
            credit_builder_enabled: true,
        })),
    ],
    _a[mock_states_1.AppMockStates.CREDIT_BUILDER_CANCELED_USER] = [
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(orchestration_1.mockGetBillStatusResponseRentPaidUpcomingPayment)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: true,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            slc_type: domain_1.SLCType.CREDIT_BUILDER,
            credit_builder_enabled: true,
        })),
    ],
    _a[mock_states_1.AppMockStates.CREDIT_BUILDER_TECHNICAL_ISSUE] = [
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: true,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            slc_type: domain_1.SLCType.CREDIT_BUILDER,
        })),
        msw_1.rest.get(routes_1.getBillStatusRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                status = ctx.status(200);
                return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('B10002', 'UncaughtException')))];
            });
        }); }),
    ],
    _a[mock_states_1.AppMockStates.PAST_DOWNPAYMENT_DEADLINE] = [msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.pastDownpaymentDeadlineBillStatus))],
    _a[mock_states_1.AppMockStates.IN_APP_DOWNPAYMENT] = [msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.updateCardBillStatus))],
    _a[mock_states_1.AppMockStates.IN_APP_DOWNPAYMENT_FAILED] = [msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.updateCardBillStatus))],
    _a[mock_states_1.AppMockStates.IN_APP_DOWNPAYMENT_RATE_LIMITING] = [msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.updateCardBillStatus))],
    _a[mock_states_1.AppMockStates.INSUFFICIENT_FUNDS] = [msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.updateCardInsufficientFundsBillStatus))],
    _a[mock_states_1.AppMockStates.GENERIC_PAYMENT_FAILURE] = [msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.updateCardGenericBillStatus))],
    _a[mock_states_1.AppMockStates.DEFAULT_PAYMENT_FAILURE] = [msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.updateCardDefaultBillStatus))],
    _a[mock_states_1.AppMockStates.SELF_PAY_VC] = [msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.selfPayVCBillStatus))],
    _a[mock_states_1.AppMockStates.DDA] = [msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.selfPayDDABillStatus))],
    _a[mock_states_1.AppMockStates.VC_ISSUED] = [msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.selfPayVCIssuedBillStatus))],
    _a[mock_states_1.AppMockStates.DDA_ISSUED] = [msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.selfPayDDAIssuedBillStatus))],
    _a[mock_states_1.AppMockStates.SELF_PAY_VC_PENDING_BEFORE_BP_CLOSE] = [
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.selfPayVCPendingBillStatus)),
    ],
    _a[mock_states_1.AppMockStates.SELF_PAY_DDA_PENDING_BEFORE_BP_CLOSE] = [
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.selfPayDDAPendingBillStatus)),
    ],
    _a[mock_states_1.AppMockStates.SELF_PAY_PENDING_AFTER_BP_CLOSE] = [msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.selfPayPendingBillStatus))],
    _a[mock_states_1.AppMockStates.BLOCK_SWITCH_TO_DEBIT] = [msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.selfPayVCIssuedBillStatus))],
    _a[mock_states_1.AppMockStates.BALANCE_TOO_HIGH] = [
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.balanceTooHighBillStatus)),
        msw_1.rest.get(routes_1.getBillPayConfigRegex, (0, utils_1.success)(fixtures_1.mockBillPayConfigurationBTHCanOverwriteLower)),
    ],
    _a[mock_states_1.AppMockStates.BTH_CANNOT_OVERWRITE] = [
        //rest.get(getBillStatusRegex, success(balanceTooHighBillStatus)),
        msw_1.rest.get(routes_1.getBillPayConfigRegex, (0, utils_1.success)(fixtures_1.mockBillPayConfigurationCannotOverwrite)),
    ],
    _a[mock_states_1.AppMockStates.BTH_CAN_OVERWRITE_HIGHER] = [
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.balanceTooHighBillStatus)),
        msw_1.rest.get(routes_1.getBillPayConfigRegex, (0, utils_1.success)(fixtures_1.mockBillPayConfigurationBTHCanOverwriteHigher)),
    ],
    _a[mock_states_1.AppMockStates.BTH_CAN_OVERWRITE_EITHER] = [
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.balanceTooHighBillStatus)),
        msw_1.rest.get(routes_1.getBillPayConfigRegex, (0, utils_1.success)(fixtures_1.mockBillPayConfigurationCanOverwrite)),
    ],
    _a[mock_states_1.AppMockStates.BALANCE_TOO_LOW] = [
        // rest.get(getBillStatusRegex, success(balanceTooLowBillStatus)),
        msw_1.rest.get(routes_1.getBillPayConfigRegex, (0, utils_1.success)(fixtures_1.mockBillPayConfigurationBTLCanOverwriteLower)),
    ],
    _a[mock_states_1.AppMockStates.BTL_CAN_OVERWRITE_HIGHER] = [
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.balanceTooLowBillStatus)),
        msw_1.rest.get(routes_1.getBillPayConfigRegex, (0, utils_1.success)(fixtures_1.mockBillPayConfigurationBTLCanOverwriteHigher)),
    ],
    _a[mock_states_1.AppMockStates.BTL_CANNOT_OVERWRITE] = [
        //rest.get(getBillStatusRegex, success(balanceTooLowBillStatus)),
        msw_1.rest.get(routes_1.getBillPayConfigRegex, (0, utils_1.success)(fixtures_1.mockBillPayConfigurationCannotOverwrite)),
    ],
    _a[mock_states_1.AppMockStates.BTL_CAN_OVERWRITE_EITHER] = [
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.balanceTooLowBillStatus)),
        msw_1.rest.get(routes_1.getBillPayConfigRegex, (0, utils_1.success)(fixtures_1.mockBillPayConfigurationCanOverwrite)),
    ],
    _a[mock_states_1.AppMockStates.YARDI_ZERO_BALANCE] = [
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.zeroBalanceBillStatus)),
        msw_1.rest.get(routes_1.getBillPayConfigRegex, (0, utils_1.success)(fixtures_1.mockBillPayConfigurationCannotOverwrite)),
    ],
    _a[mock_states_1.AppMockStates.ZERO_BALANCE] = [
        //rest.get(getBillStatusRegex, success(zeroBalanceBillStatus)),
        msw_1.rest.get(routes_1.getBillPayConfigRegex, (0, utils_1.success)(fixtures_1.mockBillPayConfigurationZeroBalanceCanOverwrite)),
    ],
    _a[mock_states_1.AppMockStates.PAST_DUE_RENT] = [msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.pastDueRentBillStatus))],
    _a[mock_states_1.AppMockStates.RELINK] = [msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(fixtures_1.relinkBillStatus))],
    _a[mock_states_1.AppMockStates.POOR_CREDIT_SCORE] = [msw_1.rest.get(routes_1.creditBuilderAccountRegex, (0, utils_1.success)(fixtures_1.poorCredit))],
    _a[mock_states_1.AppMockStates.FAIR_CREDIT_SCORE] = [msw_1.rest.get(routes_1.creditBuilderAccountRegex, (0, utils_1.success)(fixtures_1.fairCredit))],
    _a[mock_states_1.AppMockStates.GOOD_CREDIT_SCORE] = [
        msw_1.rest.get(routes_1.creditBuilderAccountRegex, (0, utils_1.success)(fixtures_1.goodCredit)),
        msw_1.rest.get(routes_1.paymentStatusRegex, (0, utils_1.success)(orchestration_1.mockGetPaymentStatusCreditBuilderMonthTwo)),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: false,
            security_deposit_amount: 125000,
            outstanding_security_deposit_amount: 0,
            slc_type: 'CREDIT_BUILDER',
            credit_builder_enabled: true,
        })),
    ],
    _a[mock_states_1.AppMockStates.VERY_GOOD_CREDIT_SCORE] = [msw_1.rest.get(routes_1.creditBuilderAccountRegex, (0, utils_1.success)(fixtures_1.veryGoodCredit))],
    _a[mock_states_1.AppMockStates.EXCELLENT_CREDIT_SCORE] = [msw_1.rest.get(routes_1.creditBuilderAccountRegex, (0, utils_1.success)(fixtures_1.excellentCredit))],
    _a[mock_states_1.AppMockStates.DECREASE_CREDIT] = [msw_1.rest.get(routes_1.creditBuilderAccountRegex, (0, utils_1.success)(fixtures_1.decreaseCredit))],
    _a[mock_states_1.AppMockStates.NO_CHANGE_CREDIT] = [msw_1.rest.get(routes_1.creditBuilderAccountRegex, (0, utils_1.success)(fixtures_1.noChangeCredit))],
    _a[mock_states_1.AppMockStates.NO_MATCH_CREDIT] = [msw_1.rest.get(routes_1.creditBuilderAccountRegex, (0, utils_1.success)(fixtures_1.noMatchCredit))],
    _a[mock_states_1.AppMockStates.FROZEN_CREDIT] = [msw_1.rest.get(routes_1.creditBuilderAccountRegex, (0, utils_1.success)(fixtures_1.frozenCredit))],
    _a[mock_states_1.AppMockStates.NO_UPDATE_CREDIT] = [msw_1.rest.get(routes_1.creditBuilderAccountRegex, (0, utils_1.success)(fixtures_1.noUpdateCredit))],
    _a[mock_states_1.AppMockStates.INSUFFICIENT_HISTORY_CREDIT] = [
        msw_1.rest.get(routes_1.creditBuilderAccountRegex, (0, utils_1.success)(fixtures_1.insufficientHistoryCredit)),
    ],
    _a[mock_states_1.AppMockStates.EMPTY_FLEX_HISTORY] = [
        msw_1.rest.get(routes_1.flexReportingHistoryRegex, (0, utils_1.success)(fixtures_1.emptyFlexHistory)),
        msw_1.rest.get(routes_1.flexRecentReportingHistoryRegex, (0, utils_1.success)(fixtures_1.emptyFlexHistory)),
    ],
    _a[mock_states_1.AppMockStates.ONE_MONTH_FLEX_HISTORY] = [
        msw_1.rest.get(routes_1.flexReportingHistoryRegex, (0, utils_1.success)(fixtures_1.oneMonthFlexHistory)),
        msw_1.rest.get(routes_1.flexRecentReportingHistoryRegex, (0, utils_1.success)(fixtures_1.oneMonthFlexHistory)),
    ],
    _a[mock_states_1.AppMockStates.FIVE_MONTH_FLEX_HISTORY] = [
        msw_1.rest.get(routes_1.flexReportingHistoryRegex, (0, utils_1.success)(fixtures_1.fiveMonthFlexHistory)),
        msw_1.rest.get(routes_1.flexRecentReportingHistoryRegex, (0, utils_1.success)(fixtures_1.oneMonthFlexHistory)),
    ],
    _a[mock_states_1.AppMockStates.ACTIVE_ROLLOVER_PROGRAM] = [
        msw_1.rest.get(routes_1.transactionDetailsRegex, (0, utils_1.success)(orchestration_1.mockTransactionDetailsActiveRollover)),
    ],
    _a[mock_states_1.AppMockStates.EMBED_ONBOARDING] = [msw_1.rest.get(routes_1.getAccountRegex, (0, utils_1.success)(orchestration_1.mockGetAccountOnboardingResponse))],
    _a[mock_states_1.AppMockStates.EMBED_PAY] = [
        msw_1.rest.get(routes_1.getAccountRegex, (0, utils_1.success)(orchestration_1.mockGetAccountResponse)),
        msw_1.rest.get(routes_1.autopilotEligibilityRegex, (0, utils_1.success)({ eligible: true, configured: false })),
        msw_1.rest.get(routes_1.getPaymentSchedule, (0, utils_1.success)({ payments: orchestration_1.mockUpdatedRentAmountScheduleEmbedEpisodic })),
    ],
    _a[mock_states_1.AppMockStates.EMBED_PAY_SLC] = [
        msw_1.rest.get(routes_1.getAccountRegex, (0, utils_1.success)(orchestration_1.mockGetAccountResponse)),
        msw_1.rest.get(routes_1.getPaymentSchedule, (0, utils_1.success)({ payments: orchestration_1.mockUpdatedRentAmountSLCScheduleEmbedEpisodic })),
        msw_1.rest.get(routes_1.autopilotEligibilityRegex, (0, utils_1.success)({ eligible: true, configured: false })),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: true,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.READY_TO_PAY_SLC_CLASSIC_EPISODIC] = [
        msw_1.rest.get(routes_1.getPaymentSchedule, (0, utils_1.success)({ payments: orchestration_1.mockUpdatedRentAmountScheduleEpisodic })),
        msw_1.rest.get(routes_1.getBillStatusRegex, (0, utils_1.success)(orchestration_1.mockGetBillStatusResponseEpisodicReadyToPay)),
        msw_1.rest.get(routes_1.autopilotEligibilityRegex, (0, utils_1.success)({ eligible: true, configured: false })),
        msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
            enabled: true,
            simplified_payments: true,
            security_deposit_amount: 10000,
            outstanding_security_deposit_amount: 2000,
            slc_type: domain_1.SLCType.CLASSIC,
        })),
    ],
    _a[mock_states_1.AppMockStates.PROPERTY_FEE_PASSTHROUGH] = [
        msw_1.rest.get(routes_1.transactionDetailsRegex, (0, utils_1.success)(orchestration_1.mockTransactionDetailsPropertyFeePassthrough)),
    ],
    _a[mock_states_1.AppMockStates.SCHEDULED] = [msw_1.rest.get(routes_1.paymentStatusRegex, (0, utils_1.success)(orchestration_1.mockGetPaymentStatusScheduled))],
    _a[mock_states_1.AppMockStates.PRE_FUND_FIRST_PAYMENT] = [msw_1.rest.get(routes_1.paymentStatusRegex, (0, utils_1.success)(orchestration_1.mockGetPaymentStatusScheduled))],
    _a[mock_states_1.AppMockStates.FLEX_FUNDS_FULLY_FUNDED_FIRST_PAYMENT] = [
        msw_1.rest.get(routes_1.paymentStatusRegex, (0, utils_1.success)(orchestration_1.mockGetPaymentStatusScheduledNoPrePay)),
        msw_1.rest.get(routes_1.walletBalanceRegex, (0, utils_1.success)(orchestration_1.mockWalletBalanceFullyFundedFirstPayment)),
    ],
    _a[mock_states_1.AppMockStates.FLEX_FUNDS_ZERO_BALANCE_FIRST_PAYMENT] = [
        msw_1.rest.get(routes_1.paymentStatusRegex, (0, utils_1.success)(orchestration_1.mockGetPaymentStatusScheduled)),
        msw_1.rest.get(routes_1.walletBalanceRegex, (0, utils_1.success)(orchestration_1.mockWalletBalanceZeroBalanceFirstPayment)),
    ],
    _a[mock_states_1.AppMockStates.FIRST_PAYMENT_PAID] = [
        msw_1.rest.get(routes_1.paymentStatusRegex, (0, utils_1.success)(orchestration_1.mockGetPaymentStatusFirstPaymentPaid)),
        msw_1.rest.get(routes_1.walletBalanceRegex, (0, utils_1.success)(orchestration_1.mockWalletBalanceFullyFundedFirstPayment)),
    ],
    _a[mock_states_1.AppMockStates.RENT_PROCESSING] = [msw_1.rest.get(routes_1.paymentStatusRegex, (0, utils_1.success)(orchestration_1.mockGetPaymentStatusSecondPayment))],
    _a[mock_states_1.AppMockStates.SECOND_PAYMENT_FAILED] = [
        msw_1.rest.get(routes_1.paymentStatusRegex, (0, utils_1.success)(orchestration_1.mockGetPaymentStatusSecondPaymentFailed)),
    ],
    _a[mock_states_1.AppMockStates.INSUFFICIENT_FUNDS] = [msw_1.rest.get(routes_1.paymentStatusRegex, (0, utils_1.success)(orchestration_1.mockGetPaymentStatusInsufficientFunds))],
    _a[mock_states_1.AppMockStates.NOT_COVERED] = [msw_1.rest.get(routes_1.paymentStatusRegex, (0, utils_1.success)(orchestration_1.mockGetPaymentStatusNotCovered))],
    _a[mock_states_1.AppMockStates.FUNDED_FIRST_PAYMENT] = [msw_1.rest.get(routes_1.paymentStatusRegex, (0, utils_1.success)(orchestration_1.mockGetPaymentStatusFirstPaymentFunded))],
    _a[mock_states_1.AppMockStates.RESCHEDULE_PAYMENT] = [msw_1.rest.get(routes_1.paymentStatusRegex, (0, utils_1.success)(orchestration_1.mockGetPaymentStatusReschedule))],
    _a);
var getOrchestrationHandlers = function (state) { return __spreadArray(__spreadArray([], (stateHandlers[state] || []), true), [
    // Terms link accept
    msw_1.rest.post(routes_1.termsLinkAcceptRegex, function (req, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
        var status, jsonBody;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    status = ctx.status(200);
                    return [4 /*yield*/, req.json()];
                case 1:
                    jsonBody = _a.sent();
                    if (jsonBody.token === 'bad-token') {
                        return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('A40000')))];
                    }
                    else if (jsonBody.token === 'expired-token') {
                        return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('A40001')))];
                    }
                    return [2 /*return*/, res(status, ctx.json(new types_1.MockSuccessResponse()))];
            }
        });
    }); }),
    msw_1.rest.post(routes_1.verifyEmailLinkRegex, function (req, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
        var status, jsonBody;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    status = ctx.status(200);
                    return [4 /*yield*/, req.json()];
                case 1:
                    jsonBody = _a.sent();
                    if (jsonBody.token === 'bad-token') {
                        return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('A40003')))];
                    }
                    else {
                        return [2 /*return*/, res(status, ctx.json(new types_1.MockSuccessResponse()))];
                    }
                    return [2 /*return*/];
            }
        });
    }); }),
    msw_1.rest.post(routes_1.acceptAgreementsRegex, (0, utils_1.success)(null)),
    msw_1.rest.get(routes_1.paymentStatusRegex, (0, utils_1.success)(orchestration_1.mockGetPaymentStatus)),
    msw_1.rest.get(routes_1.transactionHistoryRegex, (0, utils_1.success)({ items: orchestration_1.mockTransactionHistory })),
    msw_1.rest.get(routes_1.fundsActivityRegex, (0, utils_1.success)({ items: orchestration_1.mockFundsActivity })),
    msw_1.rest.get(routes_1.transactionDetailsRegex, (0, utils_1.success)(orchestration_1.mockTransactionDetails)),
    msw_1.rest.get(routes_1.postEmailVerificationRegex, (0, utils_1.success)({})),
    msw_1.rest.get(routes_1.walletSettingsRegex, (0, utils_1.success)({ enabled: true })),
    msw_1.rest.get(routes_1.walletBalanceRegex, (0, utils_1.success)(orchestration_1.mockWalletBalance)),
    msw_1.rest.get(routes_1.getCardsRegex, (0, utils_1.success)(orchestration_1.mockDebitCard)),
    msw_1.rest.post(routes_1.setupCardRegex, (0, utils_1.success)(orchestration_1.setupCardDetails)),
    msw_1.rest.post(routes_1.stripeConfirmCardSetupRegex, (0, utils_1.success)(orchestration_1.stripeConfirmCard)),
    msw_1.rest.post(routes_1.addFundsRegex, (0, utils_1.success)(null)),
    msw_1.rest.post(routes_1.withdrawFundsRegex, (0, utils_1.success)(null)),
    msw_1.rest.get(routes_1.walletEligibilityRegex, (0, utils_1.success)(orchestration_1.mockWalletEligibleUser)),
    msw_1.rest.get(routes_1.cancelBillEligibilityRegex, (0, utils_1.success)(orchestration_1.mockCancelBillEligible)),
    msw_1.rest.post(routes_1.cancelBillRegex, (0, utils_1.success)(null)),
    msw_1.rest.post(routes_1.updateEstimatedBillAmount, (0, utils_1.success)(null)),
    msw_1.rest.post(routes_1.updateCreditUtilizationAmount, (0, utils_1.success)(null)),
    msw_1.rest.get(routes_1.getPaymentSchedule, (0, utils_1.success)({ payments: orchestration_1.mockUpdatedRentAmountSchedule })),
    msw_1.rest.post(routes_1.selfPayConfirmPaymentRegex, (0, utils_1.success)(null)),
    msw_1.rest.get(routes_1.rentReportingOptInRegex, (0, utils_1.success)(orchestration_1.mockOptedInRentReporting)),
    msw_1.rest.post(routes_1.rentReportingOptInRegex, (0, utils_1.success)(null)),
    msw_1.rest.get(routes_1.deleteEligibilityRegex, (0, utils_1.success)(orchestration_1.mockDeleteAccountEligibilityTrue)),
    msw_1.rest.get(routes_1.ddaDetailsRegex, (0, utils_1.success)(orchestration_1.mockDdaDetails)),
    msw_1.rest.get(routes_1.autopilotEligibilityRegex, (0, utils_1.success)({ eligible: false, configured: false })),
    msw_1.rest.post(routes_1.autopilotEnableRegex, (0, utils_1.success)(null)),
    msw_1.rest.post(routes_1.autopilotDisableRegex, (0, utils_1.success)(null)),
    msw_1.rest.get(routes_1.getFlexAnywhereBillerIdRegex, (0, utils_1.success)(orchestration_1.mockFlexAnywhereBillerId)),
    msw_1.rest.get(routes_1.billAmountRegex, (0, utils_1.success)(orchestration_1.mockBillAmount)),
    msw_1.rest.post(routes_1.billPayNowSubmitRegex, (0, utils_1.success)(null)),
    msw_1.rest.post(routes_1.billPayNowRegex, (0, utils_1.success)({ amount_cent: 100000, pay_to: 'A Company' })),
    msw_1.rest.post(routes_1.startPhoneEmailVerifyRegex, (0, utils_1.success)({})),
    msw_1.rest.post(routes_1.startPhoneVerifyRegex, (0, utils_1.success)({ token: 'good-token' })),
    msw_1.rest.post(routes_1.verifyPhoneRegex, (0, utils_1.success)({})),
    msw_1.rest.get(routes_1.relinkEligibilityRegex, (0, utils_1.success)(orchestration_1.mockRelinkEligibilityTrue)),
    msw_1.rest.get(routes_1.rescheduleOptionsRegex, (0, utils_1.success)(orchestration_1.mockRescheduleOptions)),
    msw_1.rest.post(routes_1.rescheduleRegex, (0, utils_1.success)(null)),
    msw_1.rest.get(routes_1.getSLCStatusRegex, (0, utils_1.success)({
        enabled: false,
        simplified_payments: false,
        security_deposit_amount: 10000,
        outstanding_security_deposit_amount: 2000,
    })),
    msw_1.rest.get(routes_1.enableSimplifiedPaymentsRegex, (0, utils_1.success)(null)),
    msw_1.rest.get(routes_1.disableSimplifiedPaymentsRegex, (0, utils_1.success)(null)),
    msw_1.rest.get(routes_1.getGenericPortalsRegex, (0, utils_1.success)({ portals: fixtures_1.mockGenericPortals })),
    msw_1.rest.post(routes_1.deleteAccountRegex, (0, utils_1.success)(null)),
    msw_1.rest.get(routes_1.getAccountRegex, (0, utils_1.success)(orchestration_1.mockGetAccountResponse)),
    msw_1.rest.post(routes_1.paymentRegex, (0, utils_1.success)({})),
    msw_1.rest.get(routes_1.paymentEligibilityRegex, (0, utils_1.success)({ eligible: true, failures: [] })),
    msw_1.rest.post(routes_1.paymentBreakdownRegex, handlePaymentBreakdown),
    msw_1.rest.post(routes_1.outstandingPaymentRegex, (0, utils_1.success)({})),
    msw_1.rest.get(routes_1.outstandingPaymentEligibilityRegex, (0, utils_1.success)({ eligible: true, failures: [] })),
    msw_1.rest.post(routes_1.outstandingPaymentBreakdownRegex, handlePaymentBreakdown),
    msw_1.rest.get(routes_1.creditBuilderAccountRegex, (0, utils_1.success)(fixtures_1.goodCredit)),
    msw_1.rest.get(routes_1.flexReportingHistoryRegex, (0, utils_1.success)(fixtures_1.fiveMonthFlexHistory)),
    msw_1.rest.get(routes_1.flexRecentReportingHistoryRegex, (0, utils_1.success)(fixtures_1.oneMonthFlexHistory)),
    msw_1.rest.get(routes_1.getPortalDetailsForCustomerRegex, (0, utils_1.success)(fixtures_1.mockPortalDetails)),
    msw_1.rest.post(routes_1.updatePortalCredentialsRegex, (0, utils_1.success)(null)),
    msw_1.rest.get(routes_1.accountFeaturesRegex, (0, utils_1.success)({
        active_features: [domain_1.AccountFeature.CREDIT_BUILDER].map(function (feature) { return ({ feature: feature }); }),
    })),
    msw_1.rest.get(routes_1.getBillStatusRegex, function (_, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
        var status;
        return __generator(this, function (_a) {
            status = ctx.status(200);
            return [2 /*return*/, res(status, ctx.json(new types_1.MockErrorResponse('B10016', 'Unsupported bill status offer.')))];
        });
    }); }),
    msw_1.rest.get(routes_1.paymentStatusRegex, (0, utils_1.success)(orchestration_1.mockGetPaymentStatus)),
    msw_1.rest.get(routes_1.payNowEligibilityRegex, (0, utils_1.success)(orchestration_1.mockPayNowEligible)),
    msw_1.rest.post(routes_1.upsertUserAccountRegex, (0, utils_1.success)(fixtures_1.mockUserAccountResponse)),
    msw_1.rest.get(routes_1.getPropertyLookupRegex, (0, utils_1.success)(fixtures_1.propertyLookup)),
    msw_1.rest.get(routes_1.autopilotSetupRegex, (0, utils_1.success)(null)),
    msw_1.rest.get(routes_1.billPayNowEmbedEligibilityRegex, (0, utils_1.success)(orchestration_1.mockBillPayNowEmbedEligibilitySuccess)),
    msw_1.rest.get(routes_1.rescheduleDpOptionsRegex, (0, utils_1.success)(orchestration_1.mockRescheduleDPOptions)),
    msw_1.rest.post(routes_1.rescheduleDpRegex, (0, utils_1.success)(null)),
    msw_1.rest.get(routes_1.billRentDetailsRegex, (0, utils_1.success)(orchestration_1.mockGetRentBillDetails)),
    msw_1.rest.get(routes_1.getRentAmountSurveyRegex, (0, utils_1.success)(orchestration_1.mockGetRentAmountSurveyOptions)),
    msw_1.rest.get(routes_1.getCutoffDatesRegex, (0, utils_1.success)(orchestration_1.mockGetCutoffDates)),
], false); };
exports.getOrchestrationHandlers = getOrchestrationHandlers;
